import { render, staticRenderFns } from "./13introduce.vue?vue&type=template&id=d53ba6f6&scoped=true&"
import script from "./13introduce.vue?vue&type=script&lang=js&"
export * from "./13introduce.vue?vue&type=script&lang=js&"
import style0 from "./13introduce.vue?vue&type=style&index=0&id=d53ba6f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53ba6f6",
  null
  
)

export default component.exports